<template>
    <div>
        <form-row title="Total Earnest Money Due">
            <div class="sm:w-36 my-2">
                <div v-show="total_due_by_percent">
                    <input-money
                        :value="total_due_by_percent"
                        tabindex="-1"
                        :read_only="true"
                    />
                </div>

                <div v-show="! total_due_by_percent">
                    <input-money
                        v-model="total_due_entered"
                        :read_only="read_only"
                    />
                </div>

                <input
                    name="total_earnest_money"
                    type="hidden"
                    :value="total_due"
                    :read_only="true"
                />
            </div>

            <div class="flex flex-1 items-center my-2">
                <span class="text-sm text-gray-600 sm:pl-6 pr-6">
                    {{ $t('- OR -') }}
                </span>

                <div class="w-1/4 sm:w-1/5">
                    <input-percent
                        name="total_earnest_percent"
                        v-model="total_earnest_percent"
                        :read_only="read_only"
                    />
                </div>

                <span class="text-sm text-gray-600 leading-snug pl-4">
                    {{ $t('of') }} {{ purchase_price_formatted }} <br>{{ $t('purchase price') }}
                </span>
            </div>
        </form-row>
    </div>
</template>

<script>
import MoneyFunctions from '../../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    computed: {
        total_due_entered: {
            get() {
                return store.state.total_earnest_entered;
            },
            set(value) {
                store.state.total_earnest_entered = value;
            },
        },
        total_earnest_percent: {
            get() {
                return store.state.total_earnest_percent;
            },
            set(value) {
                store.state.total_earnest_percent = value;
            },
        },
        purchase_price() {
            return this.formatMoney(store.state.purchase_price);
        },
        total_due_by_percent() {
            return this.total_earnest_percent
                ? this.formatMoney((this.total_earnest_percent / 100) * this.moneyVal(this.purchase_price))
                : null;
        },
        total_due() {
            return this.total_due_by_percent || this.total_due_entered;
        },
        purchase_price_formatted() {
            return this.purchase_price && ! isNaN(this.purchase_price)
                ? '$' + this.formatMoneyToString(this.purchase_price)
                : '';
        },
    },

    watch: {
        total_due(val) {
            this.$emit('updateAmount', val);
            store.state.total_earnest_money = val;
        },
    },
}
</script>
